import { DISABILITY_TYPE_ID } from '../../../const';

export default [
  {
    id: 'e1f34caf-2e24-4eb6-8134-1c27fec41aa4',
    questionOrder: 6,
    readableId: DISABILITY_TYPE_ID,
    type: 'multiple',
    title: 'Are you looking for disability options?',

    helpText:
      'Choose one or more of the options below for football tailored to disabilities.',
    answers: [
      { answerId: 10, value: 'Pan disability' },
      { answerId: 1, value: 'Amputee' },
      { answerId: 2, value: 'Blind' },
      { answerId: 3, value: 'Cerebral palsy' },
      { answerId: 4, value: 'Deaf/hearing impaired' },
      { answerId: 5, value: `Down's syndrome` },
      { answerId: 6, value: 'Dwarf' },
      { answerId: 7, value: 'Frame' },
      { answerId: 8, value: 'Learning disability' },
      { answerId: 9, value: 'Mental health' },
      { answerId: 11, value: 'Partially sighted' },
      { answerId: 12, value: 'Powerchair' },
    ],
    ageRanges: [
      {
        min: 0,
        max: 0,
        nextQuestionId: '703663f0-3c99-4c4e-ac80-62184ad0546f',
      },
    ],
  },
];
